var exports = {
  "K": "x112a1f60--7bbd34--icon",
  "N": "x112a1f60--7bbd34--icon--opened",
};

module.exports = exports;
